require('./_global.js');
console.log('error js');


